import React, { useContext, createContext } from 'react'
import AppRoute from '../route/AppRoute'
import '../styles/antd/drawerStyles.css'
import { MessageInstance } from 'antd/es/message/interface'
import { message } from 'antd'

type MainScreenContextType = {
  messageApi: MessageInstance
}

const MainScreenContext = createContext<MainScreenContextType | undefined>(
  undefined
)

export const useMainScreenContext = (): MainScreenContextType => {
  const context = useContext(MainScreenContext)
  return context!
}

function MainScreen() {
  const [messageApi, contextHolder] = message.useMessage()
  return (
    <MainScreenContext.Provider
      value={{
        messageApi: messageApi,
      }}
    >
      {contextHolder}
      <AppRoute />
    </MainScreenContext.Provider>
  )
}

export default MainScreen
